// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduled-tasks-filters .react-select__control {
  height: 44px;
}
.scheduled-tasks-filters .clear-all-btn {
  height: 44px;
  border: 1px solid #9e77ed;
  color: #9e77ed;
}

.scheduled-tasks-table {
  overflow-x: visible;
  font-size: 14px !important;
}
.scheduled-tasks-table th {
  text-align: start !important;
}
.scheduled-tasks-table th.resident-header-col {
  width: 230px;
  padding: 4px 24px !important;
}
.scheduled-tasks-table th.bed-header-col {
  width: 122px;
  text-align: center !important;
}
.scheduled-tasks-table th.shifts-header-col {
  width: 154px;
  text-align: center !important;
}
.scheduled-tasks-table th.pediod-header-col {
  width: 193px;
}
.scheduled-tasks-table th.action-header-col {
  width: 85px;
}
.scheduled-tasks-table td {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  word-break: break-word;
  line-height: 20px;
}
.scheduled-tasks-table td.resident-col {
  border-right: 1px solid #cbd2e0 !important;
  width: 230px;
  padding: 4px 24px !important;
}
.scheduled-tasks-table td.bed-col {
  width: 122px;
  text-align: center;
}
.scheduled-tasks-table td.task-name-col {
  word-break: break-all;
  width: 100%;
}
.scheduled-tasks-table td.shifts-col {
  font-weight: 700;
  width: 154px;
  text-align: center !important;
}
.scheduled-tasks-table td.period-col {
  color: #667085;
  width: 193px;
}
.scheduled-tasks-table td.action-col {
  text-align: end;
  width: 85px;
}
.scheduled-tasks-table .extra-task-row {
  border-top: 1px dotted #cbd2e0 !important;
}
.scheduled-tasks-table .dropdown button {
  padding: 5px 5px;
  height: 32px;
}
.scheduled-tasks-table .react-pagination {
  border-top: 1px solid #eaecf0;
}

.edit-scheduled-task-modal {
  width: 100%;
  padding: 32px 32px 0 !important;
}
.edit-scheduled-task-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  display: flex;
  padding-top: 24px;
  padding-bottom: 24px;
  align-items: center;
  justify-content: center;
}
.edit-scheduled-task-modal .form-wrapper .select-label {
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  line-height: 16px;
}
.edit-scheduled-task-modal .form-wrapper span::before {
  width: 18px;
  height: 18px;
}
.edit-scheduled-task-modal .form-wrapper span::after {
  width: 8px;
  height: 8px;
}
.edit-scheduled-task-modal .form-wrapper .form-label {
  font-weight: 500;
}
.edit-scheduled-task-modal .form-wrapper .form-radio-group .form-control-radio:first-child {
  min-width: 150px;
}
.edit-scheduled-task-modal .form-wrapper .form-radio-group .form-control-radio {
  margin-bottom: 0;
  margin-top: 10px;
}
.edit-scheduled-task-modal .form-wrapper .form-control-select {
  margin-top: 8px;
}
.edit-scheduled-task-modal .form-wrapper .form-control-select .react-select-multi__multi-value {
  display: none;
}
.edit-scheduled-task-modal .form-wrapper .form-control-select.multi-select-days .react-select-multi__option {
  padding-top: 4px;
  padding-bottom: 4px;
}
.edit-scheduled-task-modal .form-wrapper .form-control-select.multi-select-days .react-select-multi__option::before {
  width: 18px;
  height: 18px;
  top: 6px;
}
.edit-scheduled-task-modal .form-wrapper .period-type-wrapper {
  gap: 24px;
}
.edit-scheduled-task-modal .form-wrapper .selected-shifts-list {
  margin-top: 16px;
  display: flex;
  gap: 20px;
}
.edit-scheduled-task-modal .form-wrapper .selected-shifts-list .selected-shift-item {
  display: flex;
  gap: 10px;
}
.edit-scheduled-task-modal .form-wrapper .selected-shifts-list .selected-shift-item p {
  line-height: 20px;
}
.edit-scheduled-task-modal .form-wrapper .selected-shifts-list .selected-shift-item:hover {
  color: #7f56d9;
}
.edit-scheduled-task-modal .form-wrapper .selected-shifts-list .selected-shift-item svg {
  cursor: pointer;
}
.edit-scheduled-task-modal .form-wrapper .selected-shifts-list .selected-shift-item svg:hover {
  opacity: 0.7;
}
.edit-scheduled-task-modal .form-wrapper .selected-weekdays-list {
  display: flex;
  gap: 20px;
  margin-top: 16px;
  flex-wrap: wrap;
}
.edit-scheduled-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item {
  display: flex;
  gap: 10px;
}
.edit-scheduled-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item p {
  line-height: 20px;
}
.edit-scheduled-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item:hover {
  color: #7f56d9;
}
.edit-scheduled-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item svg {
  cursor: pointer;
}
.edit-scheduled-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item svg:hover {
  opacity: 0.7;
}
.edit-scheduled-task-modal .form-wrapper .react-select-multi__menu {
  width: 100%;
  max-width: unset;
  min-width: unset;
}
.edit-scheduled-task-modal .form-wrapper .selected-tasks-list {
  display: block;
  margin-top: 16px;
}
.edit-scheduled-task-modal .form-wrapper .selected-tasks-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}
.edit-scheduled-task-modal .form-wrapper .selected-tasks-item p {
  width: fit-content;
}
.edit-scheduled-task-modal .form-wrapper .selected-tasks-item:hover {
  color: #7f56d9;
}
.edit-scheduled-task-modal .form-wrapper .selected-tasks-item svg {
  cursor: pointer;
}
.edit-scheduled-task-modal .form-wrapper .selected-tasks-item svg:hover {
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/pages/cna/assignments/unit/components/scheduled-tasks-tab-panel/styles.scss"],"names":[],"mappings":"AACE;EACE,YAAA;AAAJ;AAGE;EACE,YAAA;EACA,yBAAA;EACA,cAAA;AADJ;;AAKA;EACE,mBAAA;EACA,0BAAA;AAFF;AAIE;EACE,4BAAA;AAFJ;AAII;EACE,YAAA;EACA,4BAAA;AAFN;AAKI;EACE,YAAA;EACA,6BAAA;AAHN;AAMI;EACE,YAAA;EACA,6BAAA;AAJN;AAOI;EACE,YAAA;AALN;AAQI;EACE,WAAA;AANN;AAUE;EACE,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;AARJ;AAUI;EACE,0CAAA;EACA,YAAA;EACA,4BAAA;AARN;AAWI;EACE,YAAA;EACA,kBAAA;AATN;AAYI;EACE,qBAAA;EACA,WAAA;AAVN;AAaI;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;AAXN;AAcI;EACE,cAAA;EACA,YAAA;AAZN;AAeI;EACE,eAAA;EACA,WAAA;AAbN;AAiBE;EACE,yCAAA;AAfJ;AAmBI;EACE,gBAAA;EACA,YAAA;AAjBN;AAqBE;EACE,6BAAA;AAnBJ;;AAuBA;EACE,WAAA;EACA,+BAAA;AApBF;AAsBE;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AApBJ;AAwBI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AAtBN;AAyBI;EACE,WAAA;EACA,YAAA;AAvBN;AA0BI;EACE,UAAA;EACA,WAAA;AAxBN;AA2BI;EACE,gBAAA;AAzBN;AA6BM;EACE,gBAAA;AA3BR;AA8BM;EACE,gBAAA;EACA,gBAAA;AA5BR;AAgCI;EACE,eAAA;AA9BN;AAgCM;EACE,aAAA;AA9BR;AAkCQ;EACE,gBAAA;EACA,mBAAA;AAhCV;AAkCU;EACE,WAAA;EACA,YAAA;EACA,QAAA;AAhCZ;AAsCI;EACE,SAAA;AApCN;AAuCI;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AArCN;AAuCM;EACE,aAAA;EACA,SAAA;AArCR;AAuCQ;EACE,iBAAA;AArCV;AAwCQ;EACE,cAAA;AAtCV;AAwCQ;EACE,eAAA;AAtCV;AAwCU;EACE,YAAA;AAtCZ;AA4CI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AA1CN;AA4CM;EACE,aAAA;EACA,SAAA;AA1CR;AA4CQ;EACE,iBAAA;AA1CV;AA6CQ;EACE,cAAA;AA3CV;AA6CQ;EACE,eAAA;AA3CV;AA6CU;EACE,YAAA;AA3CZ;AAiDI;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AA/CN;AAmDM;EACE,cAAA;EACA,gBAAA;AAjDR;AAoDM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAlDR;AAoDQ;EACE,kBAAA;AAlDV;AAqDQ;EACE,cAAA;AAnDV;AAqDQ;EACE,eAAA;AAnDV;AAqDU;EACE,YAAA;AAnDZ","sourcesContent":[".scheduled-tasks-filters {\n  .react-select__control {\n    height: 44px;\n  }\n\n  .clear-all-btn {\n    height: 44px;\n    border: 1px solid #9e77ed;\n    color: #9e77ed;\n  }\n}\n\n.scheduled-tasks-table {\n  overflow-x: visible;\n  font-size: 14px !important;\n\n  th {\n    text-align: start !important;\n\n    &.resident-header-col {\n      width: 230px;\n      padding: 4px 24px !important;\n    }\n\n    &.bed-header-col {\n      width: 122px;\n      text-align: center !important;\n    }\n\n    &.shifts-header-col {\n      width: 154px;\n      text-align: center !important;\n    }\n\n    &.pediod-header-col {\n      width: 193px;\n    }\n\n    &.action-header-col {\n      width: 85px;\n    }\n  }\n\n  td {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n    word-break: break-word;\n    line-height: 20px;\n\n    &.resident-col {\n      border-right: 1px solid #cbd2e0 !important;\n      width: 230px;\n      padding: 4px 24px !important;\n    }\n\n    &.bed-col {\n      width: 122px;\n      text-align: center;\n    }\n\n    &.task-name-col {\n      word-break: break-all;\n      width: 100%;\n    }\n\n    &.shifts-col {\n      font-weight: 700;\n      width: 154px;\n      text-align: center !important;\n    }\n\n    &.period-col {\n      color: #667085;\n      width: 193px;\n    }\n\n    &.action-col {\n      text-align: end;\n      width: 85px;\n    }\n  }\n\n  .extra-task-row {\n    border-top: 1px dotted #cbd2e0 !important;\n  }\n\n  .dropdown {\n    button {\n      padding: 5px 5px;\n      height: 32px;\n    }\n  }\n\n  .react-pagination {\n    border-top: 1px solid #eaecf0;\n  }\n}\n\n.edit-scheduled-task-modal {\n  width: 100%;\n  padding: 32px 32px 0 !important;\n\n  &-overlay {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n    display: flex;\n    padding-top: 24px;\n    padding-bottom: 24px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .form-wrapper {\n    .select-label {\n      font-size: 14px;\n      font-weight: 500;\n      display: inline-block;\n      line-height: 16px;\n    }\n\n    span::before {\n      width: 18px;\n      height: 18px;\n    }\n\n    span::after {\n      width: 8px;\n      height: 8px;\n    }\n\n    .form-label {\n      font-weight: 500;\n    }\n\n    .form-radio-group {\n      .form-control-radio:first-child {\n        min-width: 150px;\n      }\n\n      .form-control-radio {\n        margin-bottom: 0;\n        margin-top: 10px;\n      }\n    }\n\n    .form-control-select {\n      margin-top: 8px;\n\n      .react-select-multi__multi-value {\n        display: none;\n      }\n\n      &.multi-select-days {\n        .react-select-multi__option {\n          padding-top: 4px;\n          padding-bottom: 4px;\n\n          &::before {\n            width: 18px;\n            height: 18px;\n            top: 6px;\n          }\n        }\n      }\n    }\n\n    .period-type-wrapper {\n      gap: 24px;\n    }\n\n    .selected-shifts-list {\n      margin-top: 16px;\n      display: flex;\n      gap: 20px;\n\n      .selected-shift-item {\n        display: flex;\n        gap: 10px;\n\n        p {\n          line-height: 20px;\n        }\n\n        &:hover {\n          color: #7f56d9;\n        }\n        svg {\n          cursor: pointer;\n\n          &:hover {\n            opacity: 0.7;\n          }\n        }\n      }\n    }\n\n    .selected-weekdays-list {\n      display: flex;\n      gap: 20px;\n      margin-top: 16px;\n      flex-wrap: wrap;\n\n      .selected-weekdays-item {\n        display: flex;\n        gap: 10px;\n\n        p {\n          line-height: 20px;\n        }\n\n        &:hover {\n          color: #7f56d9;\n        }\n        svg {\n          cursor: pointer;\n\n          &:hover {\n            opacity: 0.7;\n          }\n        }\n      }\n    }\n\n    .react-select-multi__menu {\n      width: 100%;\n      max-width: unset;\n      min-width: unset;\n    }\n\n    .selected-tasks {\n      &-list {\n        display: block;\n        margin-top: 16px;\n      }\n\n      &-item {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin: 10px 0;\n\n        p {\n          width: fit-content;\n        }\n\n        &:hover {\n          color: #7f56d9;\n        }\n        svg {\n          cursor: pointer;\n\n          &:hover {\n            opacity: 0.7;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
